export enum Interval {
  FIVE_SEC = 5_000,
  TEN_SEC = 10_000,
  FIFTEEN_SEC = 15_000,
  THIRTY_SEC = 30_000,
  ONE_MIN = 60_000,
  FIVE_MIN = 300_000,
  ONE_HOUR = 3_600_000,
}